import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import styles from './multilayer-process-bar.module.css'

const propTypes = {
    bars: PropTypes.arrayOf(
        PropTypes.shape({
            className: PropTypes.string,
            max: PropTypes.number,
            value: PropTypes.number
        })
    ),
    className: PropTypes.string,
    max: PropTypes.number
}

const defaultProps = {
    max: 1
}

export function MultilayerProcessBar({ bars, className, max }) {
    const currentBarClassNames = cx(styles['outside'], className)

    return (
        <div className={currentBarClassNames}>
            {bars.map(({ className, max: barMax, value }, index) => {
                const width = `${Math.round((value * 100) / (barMax || max))}%`
                return (
                    <span key={index} className={cx(styles['bar'], className, styles['bar-base'])} style={{ width }} />
                )
            })}
        </div>
    )
}

MultilayerProcessBar.propTypes = propTypes
MultilayerProcessBar.defaultProps = defaultProps
